import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { Button, Link } from '@mui/material'
import { LoaderInCentalPosition } from 'widget/LoaderInCentalPosition/LoaderInCentalPosition'

import style from './BottomSection.module.scss'

const BottomSection = ({
  disabled,
  isLoading,
}: {
  disabled: boolean
  isLoading: boolean
}) => (
  <div className={style.bottomSection}>
    <Button
      type='submit'
      variant='contained'
      classes={{ root: style.btn }}
      endIcon={<ChevronRightIcon />}
      disabled={disabled}
      data-testid='sms-code-submit'
    >
      {isLoading && <LoaderInCentalPosition className={style.loader} />}
      Далее
    </Button>
    <p className={style.codeProblem}>
      Не приходит код? Позвоните на горячую линию&nbsp;
      <Link href='tel:88002002208' underline='hover'>
        8 (800) 200-22-08
      </Link>
    </p>
  </div>
)

export default BottomSection
